import { render, staticRenderFns } from "./ScoutTopicCandidate.vue?vue&type=template&id=379e4d83"
import script from "./ScoutTopicCandidate.vue?vue&type=script&lang=js"
export * from "./ScoutTopicCandidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports